var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-input",
    {
      ref: "clipboardInput",
      attrs: { label: _vm.label, value: _vm.value, readonly: "" },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "template",
        { slot: "inlineIcon" },
        [
          _c("ui-button", {
            attrs: { disabled: _vm.disabled, dense: "", icon: "fa fa-paste" },
            on: { click: _vm.copyInputToClipboard },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }